import { Outlet } from "react-router";
import { ToastProvider } from "@/components/ds";
import { DashboardNav } from "@/components/app/DashboardNav";
import { AuthGuard } from "../AuthGuard";

export function AppLayout() {
  return (
    <AuthGuard>
      <ToastProvider>
        <DashboardNav>
          <Outlet />
        </DashboardNav>
      </ToastProvider>
    </AuthGuard>
  );
}
